module.exports = __webpack_public_path__ + "static/media/inactive-camera-icon.2bc53845.svg";